import React from "react";
import "./project.css";
import GitHubIcon from "@mui/icons-material/GitHub";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

export default function ProjectCard(props) {
  const isExternalLive =
    props.live && !props.live.includes("github.com");

  return (
    <article className="project-card">
      <h3 className="project-title">{props.heading}</h3>
      <ul className="project-desc">
        {props.desc["desc"].map((data, id) => (
          <li key={id}>{data}</li>
        ))}
      </ul>
      <div className="project-links">
        {props.github && (
          <a href={props.github} target="_blank" rel="noreferrer">
            <GitHubIcon fontSize="small" /> Code
          </a>
        )}
        {isExternalLive && (
          <a href={props.live} target="_blank" rel="noreferrer">
            <OpenInNewIcon fontSize="small" /> Live
          </a>
        )}
      </div>
    </article>
  );
}
